// extracted by mini-css-extract-plugin
export var brand = "_b3-9";
export var compact = "_b3-6";
export var extraSmall = "_b3-7";
export var icon = "_b3-0";
export var large = "_b3-4";
export var light = "_b3-1";
export var medium = "_b3-5";
export var outline = "_b3-b";
export var primaryDark = "_b3-a";
export var primaryLight = "_b3-8";
export var primaryModern = "_b3-c";
export var success = "_b3-2";
export var successSolid = "_b3-3";